const PLAN_TO_BADGE: Record<string, { label: string; className: string }> = {
  platinum: { label: "Platinum Shop", className: "bg-[#7C3AED] text-white" },
  gold: { label: "Gold Shop", className: "bg-[#F59E0B] text-white" },
  silver: { label: "Silver Shop", className: "bg-[#94A3B8] text-white" },
};

interface MembershipPlanBadgeProps {
  plan?: string | null;
  className?: string;
}

export function MembershipPlanBadge({
  plan,
  className = "",
}: MembershipPlanBadgeProps) {
  const key = String(plan || "").trim().toLowerCase();
  const cfg = PLAN_TO_BADGE[key];
  if (!cfg) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-sm px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${cfg.className} ${className}`.trim()}
    >
      {cfg.label}
    </span>
  );
}
